var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AppConfig } from '../../config/config';
export function fetchBoost(r) {
    return __awaiter(this, void 0, void 0, function* () {
        const { apiUrl, shop } = AppConfig.searchSettings.boost;
        const { q, page, pageSize, sort, pg = 'collection_page', collectionHandle = '*' } = r;
        const params = new URLSearchParams({
            q: q || '*',
            page: String(page || 1),
            limit: String(pageSize || 24),
            shop,
            build_filter_tree: 'true',
            return_all_currency_fields: 'false',
            pg,
        });
        if (sort) {
            const sortMap = {
                title_asc: 'title-ascending',
                title_desc: 'title-descending',
                price_asc: 'price-ascending',
                price_desc: 'price-descending',
                relevance: 'relevance',
            };
            params.append('sort', sortMap[sort] || sort);
        }
        // Handle filters
        if (r.filters) {
            Object.entries(r.filters).forEach(([filterId, values]) => {
                if (values.length) {
                    if (filterId.includes('review_ratings') || filterId.includes('rating')) {
                        values.forEach(value => {
                            let transformedValue = value;
                            if (value.includes('-')) {
                                const fromValue = parseFloat(value.split('-')[0]);
                                const starCount = Math.ceil(fromValue);
                                transformedValue = `${starCount}.0-${starCount}.9`;
                            }
                            params.append(`${filterId}[]`, transformedValue);
                        });
                    }
                    else {
                        values.forEach(value => {
                            params.append(`${filterId}[]`, value);
                        });
                    }
                }
            });
        }
        // Handle collection search
        if (collectionHandle) {
            params.append('collection_scope', collectionHandle);
        }
        const url = `${apiUrl}${pg === 'collection_page' ? '/filter' : '/search'}?${params.toString()}`;
        const response = yield fetch(url, {
            headers: {
                'Accept-Encoding': 'gzip',
            },
        });
        if (!response.ok) {
            throw new Error(`Boost API error: ${response.statusText}`);
        }
        return response.json();
    });
}
export function fetchBoostCollections(r) {
    return __awaiter(this, void 0, void 0, function* () {
        const { apiUrl, shop } = AppConfig.searchSettings.boost;
        const { q, page, pageSize, pg = 'search_page', sort } = r;
        const params = new URLSearchParams({
            q: q || '*',
            page: String(page || 1),
            limit: String(pageSize || 24),
            shop,
            pg,
        });
        if (sort) {
            const sortMap = {
                title_asc: 'title-ascending',
                title_desc: 'title-descending',
                price_asc: 'price-ascending',
                price_desc: 'price-descending',
                relevance: 'relevance',
            };
            params.append('sort', sortMap[sort] || sort);
        }
        const url = `${apiUrl}/search/collections?${params.toString()}`;
        const response = yield fetch(url, {
            headers: {
                'Accept-Encoding': 'gzip',
            },
        });
        if (!response.ok) {
            throw new Error(`Boost API error: ${response.statusText}`);
        }
        return response.json();
    });
}
export function fetchBoostPages(r) {
    return __awaiter(this, void 0, void 0, function* () {
        const { apiUrl, shop } = AppConfig.searchSettings.boost;
        const { q, page, pageSize, pg = 'search_page', sort } = r;
        const params = new URLSearchParams({
            q: q || '*',
            page: String(page || 1),
            limit: String(pageSize || 24),
            shop,
            pg,
        });
        if (sort) {
            const sortMap = {
                title_asc: 'title-ascending',
                title_desc: 'title-descending',
                price_asc: 'price-ascending',
                price_desc: 'price-descending',
                relevance: 'relevance',
            };
            params.append('sort', sortMap[sort] || sort);
        }
        const url = `${apiUrl}/search/pages?${params.toString()}`;
        const response = yield fetch(url, {
            headers: {
                'Accept-Encoding': 'gzip',
            },
        });
        if (!response.ok) {
            throw new Error(`Boost API error: ${response.statusText}`);
        }
        return response.json();
    });
}
